<template>
  <div id="user-top-desktop" class="border-radius-bottom hidden-xs hidden-sm mr-20 flex" style="float:right;">
    <!-- <div class="hut-rewards--flat-button">
      <router-link :to="{name: 'hut-rewards'}" hreflang="en-MY">
        <span class="hut-rewards-logo"></span>
      </router-link>
    </div> -->

<!--    <div v-if="$auth.check()" class="hut-rewards&#45;&#45;flat-button">-->
<!--      <router-link to="/order">-->
<!--        <img src="@/assets/images/icons/cart.png" alt="View your cart" title="View your cart"-->
<!--             class="img-track" width="25">-->
<!--        <span v-if="amount > 0" class="num-cart">-->
<!--          {{amount}}-->
<!--        </span>-->

<!--      </router-link>-->
<!--    </div>-->

    <div class="hut-rewards--flat-button">
      <div v-if="!$auth.check()" class="login-box">
        <router-link to="/login" hreflang="en-MY">
          <!--<img src="https://static.phdvasia.com/jp/icons/inactive@2x.png" class="" width="22">-->
          <!-- <img src="https://static.phdvasia.com/my/fcds/icons/inactive.png"> -->
          <strong class="ml-5 mr-5">{{ $t("login_to") }}</strong>
          <span class="hut-rewards-logo mr-5" style="margin-top: 3px"></span>
          <span class="caret"></span>
        </router-link>
      </div>
      <div v-if="$auth.check()" class="login-box">
        <!--<router-link to="/profile">
          <strong> {{$t('hello')}}, {{$auth.user().first_name}} {{$auth.user().last_name}}</strong>
        </router-link>-->

        <div v-if="$i18n.locale == $const.LANG_JP">
          <strong><router-link to="/profile">{{$t('full_name_format', {last_name:$auth.user().last_name})}}</router-link></strong>
        </div>
        <div class="login_full_name text-uppercase" v-else>
          <img src="https://static.phdvasia.com/my/fcds/icons/inactive.png">
          <router-link class="xs-text-gray-medium" to="/profile">{{$t('full_name_format', {say_hi:'Hi!',first_name:$auth.user().first_name, last_name:$auth.user().last_name})}}</router-link>
        </div>

      </div>
    </div>
    <div class="hut-rewards--flat-button">
      <div v-if="$auth.check()" class="login-box">
        <div class="flag-inner">
          <a class="xs-text-gray-medium t14 font-weight-600" v-on:click="$root.$emit('logout')">{{ $t("button_logout")}}</a>
        </div>
      </div>
    </div>
    <div class="hut-rewards--flat-button"  v-if="$auth.check()">
      <div class="login-box">
        <div class="flag-inner">
          <router-link :to="{name: 'hut-rewards'}" hreflang="en-MY">
            <span>{{(cart.customer_point != undefined ? cart.customer_point : ($auth.user().point ? $auth.user().point : 0))}} {{ $t("slices")}}
              <img style="max-width: 20px;" src="https://static.phdvasia.com/my/fcds/hutawards/pizza-icon.png">
            </span>
          </router-link>
        </div>
      </div>
    </div>

    <div class="hut-rewards--flat-button">
      <div class="login-box">
        <router-link to="/tracking" class="font-weight-600" hreflang="en-MY">
          <img :src="$const.DOMAIN_STATIC + '/icons/track_your_order.svg'" class="" width="22">
          <strong>{{ $t("track_your_order")}}</strong>
        </router-link>
      </div>
    </div>


    <!--<div v-for="item in langList"-->
      <!--class="hut-rewards&#45;&#45;flat-button">-->
      <!--<div v-if="$const.LANGUAGES[item]"-->
        <!--class="flag-inner">-->
        <!--<a @click="setLang(item)">-->
          <!--<img :src="$const.LANGUAGES[item]['image']"-->
               <!--class="xs-mr-5">-->
          <!--<span>{{ $const.LANGUAGES[item]['text'] }}</span>-->
        <!--</a>-->
      <!--</div>-->
    <!--</div>-->
  </div>
</template>
<style>
  .login_full_name {
    display: flex;
    padding-left: 5px;
  }

  .login_full_name a {
    font-size: 14px;
    font-weight: 600;
  }
</style>

<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex'

export default {
	mounted: function () {
    this.$cart.init(this)
    var vm = this
    this.$root.$on('cartUpdate', () => {
      vm.$cart.init(vm)
      vm.amount = vm.getTotalCartItem(vm.cart)
    })
    vm.amount = this.getTotalCartItem(this.cart)
	},
  destroyed () {
    this.$root.$off('cartUpdate')
  },
	data() {
		return {
		  amount: 0,
      languages: this.$const.LANGUAGES
    }
	},
  computed: {
    ...mapGetters({
      langList: 'langList'
    }),
    layout() {
      return (this.$route.meta.layout || defaultLayout) + '-layout'
    }
  },
	methods: {
		setLang: function (lang) {
			this.$store.dispatch('setLang', lang)
			this.$session.set('lang', lang)
			this.$router.go(this.$router.currentRoute)
		}
	}
}

</script>



// WEBPACK FOOTER //
// src/components/home/HomeUserTopDesktop.vue